import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FactoryEmployeeAttendanceReport } from './Pages/listing';

export const FactoryEmployeeAttendanceReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={FactoryEmployeeAttendanceReport} />
    </Fragment>
)